import { StudentDashboardFilters } from '@/data/services/studentDashboardStatsServices';

type DashboardCourseProgressesParams = {
  studentId?: number;
  enrollmentsCount: number;
};

export default function dashboardCourseProgressesQueryFilters({
  studentId,
  enrollmentsCount,
}: DashboardCourseProgressesParams): StudentDashboardFilters {
  return {
    studentId,
    isActive: true,
    startSoon: enrollmentsCount > 1 ? false : undefined,
    ordering: '-created_at',
  };
}
